import { render, staticRenderFns } from "./LoginAs.vue?vue&type=template&id=1f447d9e&scoped=true&"
import script from "./LoginAs.vue?vue&type=script&lang=js&"
export * from "./LoginAs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f447d9e",
  null
  
)

export default component.exports